import React, { useState } from 'react';
import './GundamCard.scss';

const GundamCard = ({ product }) => {
  const [currentImage, setCurrentImage] = useState(product.images[0]);
  const handleProductClick = url => {
    if (url?.length > 0 && url.includes('sg/en/')) {
      window.location.assign(`/${url}`);
    } else {
      window.location.assign(`/sg/en/${url}`);
    }
  };

  return (
    <div
      className="gundam-slider-card"
      onClick={() => handleProductClick(product.url)}
      onMouseEnter={() => setCurrentImage(product.altImages[0])}
      onMouseLeave={() => setCurrentImage(product.images[0])}
    >
      <div
        className={`gundam-slider-card__image__wrapper ${
          product.modelNumber === 'ZAKU-CASE3A' ? 'gundam-slider-card__image__wrapper__zaku' : ''
        }`}
      >
        <img alt="gundam" className="gundam-slider-card__image" src={currentImage} />
      </div>
      <div className="gundam-slider-card__title">
        Gundam <span>({product.modelNumber})</span>
      </div>
      <div className="gundam-slider-card__price">{product.price}</div>
    </div>
  );
};

export default GundamCard;
